import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscriber, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router) { }


  login(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/login', item).pipe(
      tap((response: any) => {
        // Stocker le token dans le localStorage
        localStorage.setItem('loginTime', Date.now().toString());

        localStorage.setItem('access_token_obgrm', response.data.token);
      })
    );
  }
  logout() {
    localStorage.removeItem('access_token_obgrm');
    localStorage.removeItem('loginTime');
    this.router.navigate(['/login']);
  }
 isSessionExpired(): boolean {
  const loginTime = localStorage.getItem('loginTime');
  if (!loginTime) return true;

  const now = Date.now();
  const testDuration = 1 * 60 * 1000; // 1 minute

  return (now - parseInt(loginTime)) > testDuration;
}

  updateProfil(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/update-user-data', item);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('access_token_obgrm');
  }


  checkEmail(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/identite', item);
  }



  register(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/register', item);
    // return this.http.post(environment.apiUrl + 'signin',item);
  }


  reset(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/forgot-password`, {
      email_address: item
    });
  }


  addGestionUser(item: any): Observable<any> {
    ////console.log("webservice");

    return this.http.post(environment.apiUrl + 'auth/register', item);
  }
  editGestionUser(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/update-user`, item);
  }

  deleteGestionUser(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `auth/remove-user/${id}`);
  }


  deletePta(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/remove-pta`, item);
  }

  deletePdc(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/remove-pdc`, item);
  }


}
